<template>
  <main class="main" style="background-color: white;min-height: calc(100vh - 60px);overflow: auto;">
    <portal to="headerTitle">
      Access Control
    </portal>
    <template v-if="token !== null">
      <hm-col v-if="!isNil(token)" cols="12">
        <seam-device-table :client-session-token="token" />
      </hm-col>
    </template>
    <spinner-overlay v-if="showSpinner" />
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil } from 'lodash';
import HmCardInner from '../../../lib/layout/HmCardInner';
import TimerMixin from '../../../../mixins/TimerMixin';
// import '@seamapi/react/dist/elements';

export default {
  name: 'PageChannelManagerCxIframe',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, TimerMixin],

  data() {
    return {
      token: null,
      showSpinner: true,
    };
  },

  computed: {
  },

  watch: {
    token: function (newVal) {
      if (isNil(newVal)) this.showSpinner = true;
      else this.setTimeout(() => { this.showSpinner = false; }, 2500);
    },
  },

  created: function () {
    this.loadData();
    // this.token = 'seam_cst1KATDNn6h_5AMgU7XfYXCtLJJ6vbzfi1YH';
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.locking.seam.session(this, this.$route.params.interfaceId))
        .then((response) => {
          this.token = response.data.data.token;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageLockingSeamIframe.vue